export default {
  support: [
    {
      name: 'Trang chủ Orbro',
      path: '/vi/',
      start: 'Bắt đầu',
    },
    {
      name: 'Hỗ trợ',
      submenus: [
        { text: 'Công nghệ', path: '/vi/enterprise/technology/uwb' },
        { text: 'Blog', path: '/vi/blog' },
        { text: 'Liên hệ kinh doanh', path: '/vi/request' },
        { text: 'Giới thiệu công ty', path: '/vi/company' },
      ],
    },
  ],

  lang: [
    {
      name: 'Ngôn ngữ',
      submenus: [{ text: '한국어' }, { text: 'Tiếng Việt' }, { text: 'English' }, { text: '日本語' }, { text: '中文' }],
    },
  ],
};
